module.exports = __webpack_public_path__ + "img/banner-uber.10de9760.jpg";